import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, zip, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { AmapUILoaderService } from '../../shared/amap-ui-loader.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { Getter } from '../../base/interfaces';
import { AMapUISimpleMarker } from '../ui-simple-marker/ui-simple-marker.service';

export namespace AMapUIAwesomeMarker {
  export interface Options<ExtraData = any> extends AMapUISimpleMarker.Options<ExtraData> {
    /**
     * icon çåç§°ï¼å¯ç¨ç icons åè§ Font Awesome å®ç½
     */
    awesomeIcon?: string;
    /**
     * è¿åå­ä½èç¹ä¸ç classNames
     */
    getClassnamesOfAwesomeIcon?: (awesomeIcon: string) => string;
  }
}

const TAG = 'UIAwesomeMarker';

@Injectable()
export class UIAwesomeMarkerService implements Getter<any> {
  private marker: any;
  private marker$ = new ReplaySubject<any>(1);
  private ui = this.uiLoader.load('overlay/AwesomeMarker') as Observable<any>;

  constructor(
    private amaps: AMapService,
    private uiLoader: AmapUILoaderService,
    private logger: LoggerService,
    private ngZone: NgZone,
  ) {}

  /**
   * è·åç¹æ è®°
   */
  get() {
    return this.marker$.asObservable();
  }

  /**
   * åå»ºç¹æ è®° AMap.AwesomeMarker
   * @param options éé¡¹
   * @param addToMap æ¯å¦ç´æ¥å è¿å°å¾
   */
  create(options: AMapUIAwesomeMarker.Options, addToMap = true) {
    return zip(this.ui, this.amaps.get()).pipe(
      map(([AwesomeMarker, m]) => {
        if (addToMap) {
          options.map = m;
        }
        this.marker = this.ngZone.runOutsideAngular(() => new AwesomeMarker(options));
        this.logger.d(TAG, 'new awesome marker created.');
        this.marker$.next(this.marker);
        this.marker$.complete();
        return this.marker;
      }),
    );
  }

  /**
   * éæ¯ç¹æ è®°
   */
  destroy() {
    this.get().subscribe(m => {
      m.setMap(null);
      this.logger.d(TAG, 'awesome marker destroyed.');
      this.marker = null;
    });
  }
}
